import React, { useState } from "react";

import { Box, Button, Callout, Dialog, Intent, Text, TextInput } from "@blasterjs/core";

import { DialogBody, DialogFooter, DialogHeader } from "../components/DialogLayout";
import { useAppDispatch, useAppSelector } from "../hooks";
import { closeCopyImageDialog, imageCopy, setCopyImageForm } from "../slices/copyImageDialog";

const CopyImageDialog = () => {
  const dispatch = useAppDispatch();
  const copyImageDialog = useAppSelector(state => state.copyImageDialog);

  const [isConfirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  const closeDialog = () => {
    dispatch(closeCopyImageDialog());
  };

  const onConfirm = (_: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmationDialogOpen(false);
    dispatch(imageCopy());
  };

  const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    copyImageDialog.isOpen &&
      dispatch(
        setCopyImageForm({
          duplicateImageName: e.target.value,
          accessionNumber: copyImageDialog.image.data.accessionNumber
        })
      );
  };

  const onAccessionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    copyImageDialog.isOpen &&
      dispatch(
        setCopyImageForm({
          duplicateImageName: copyImageDialog.image.data.duplicateImageName,
          accessionNumber: e.target.value
        })
      );
  };

  const errorText =
    copyImageDialog.isOpen && "errorMessage" in copyImageDialog.image ? (
      <Box mb={2}>
        <Callout intent={Intent.DANGER}>
          <Text>{copyImageDialog.image.errorMessage}</Text>
        </Callout>
      </Box>
    ) : null;

  return (
    <>
      <Dialog
        isOpen={copyImageDialog.isOpen && !isConfirmationDialogOpen}
        onRequestClose={closeDialog}
        appElementId="root"
      >
        <DialogHeader title="Copy Image" closeDialog={closeDialog} />
        <DialogBody>
          {errorText}
          <Box style={{ marginTop: 12 }}>
            <Text>Image Name:</Text>
            <TextInput
              value={
                (copyImageDialog.isOpen && copyImageDialog.image.data.duplicateImageName) || ""
              }
              onChange={onNameChange}
            />
          </Box>
          <Box style={{ marginTop: 12 }}>
            <Text>Accession Number:</Text>
            <TextInput
              value={(copyImageDialog.isOpen && copyImageDialog.image.data.accessionNumber) || ""}
              onChange={onAccessionChange}
            />
          </Box>
        </DialogBody>
        <DialogFooter>
          <Button
            onClick={onConfirm}
            appearance="prominent"
            intent="primary"
            isLoading={
              copyImageDialog.isOpen &&
              "isPending" in copyImageDialog.image &&
              copyImageDialog.image.isPending
            }
          >
            Copy image
          </Button>
          <Button onClick={closeDialog}>Cancel</Button>
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default CopyImageDialog;
